import {
    ALMACENAR_ANAMNESIS,
    ALMACENAR_ANAMNESIS_EXITO,
    ALMACENAR_ANAMNESIS_ERROR,
    SOLICITO_ANAMNESIS_EXITO
} from '../types';

import clienteAxios from '../config/axios';

import Swal from 'sweetalert2';


/*
====================================
ALMACENAR ANAMNESIS ESTRUCTURADA
====================================

Primer guardado:
- Crea la Anamnesis.
- Inicia el plazo de 24 horas.

Dentro de las primeras 24 horas:
- Guarda los cambios sin adenda.

Después de las 24 horas:
- Si falta confirmar la adenda,
  el backend responde 409.
- Devolvemos requiere_adenda: true
  para que el componente abra el modal.
- Si se envía una adenda confirmada,
  el backend guarda conjuntamente
  los cambios y la adenda.
====================================
*/

export function almacenarAnamnesisAction(informacion) {

    return async (dispatch) => {

        dispatch(
            almacenarAnamnesis()
        );

        try {

            const {
                config,
                payload
            } = informacion;


            /*
            ====================================
            ENVIAR DATOS AL BACKEND
            ====================================

            El payload puede contener el objeto
            "adenda" cuando el profesional ya
            confirmó el modal.
            ====================================
            */

            const respuesta = await clienteAxios.post(
                '/paciente/almacenaranamnesis',
                payload,
                config
            );


            /*
            ====================================
            GUARDADO EXITOSO
            ====================================
            */

            dispatch(
                almacenarAnamnesisExito(
                    respuesta.data
                )
            );


            /*
            ====================================
            ACTUALIZAR ANAMNESIS EN REDUX
            ====================================

            Conservamos los datos clínicos que
            acabamos de guardar.

            No incorporamos el objeto "adenda"
            dentro de info_anamnesis, porque
            es un registro independiente.

            Incorporamos fecha_creacion devuelta
            por el backend para conservar el
            inicio original del plazo de 24 horas.
            ====================================
            */

            const {
                adenda,
                ...datosAnamnesis
            } = payload;


            dispatch(
                solicitarAnamnesisExito({

                    ...datosAnamnesis,

                    fecha_creacion:
                        respuesta.data.fecha_creacion

                })
            );


            /*
            ====================================
            CONFIRMACIÓN AL PROFESIONAL
            ====================================
            */

            Swal.fire(
                'Correcto',
                'Guardado con éxito',
                'success'
            );


            /*
            ====================================
            RESULTADO PARA EL COMPONENTE
            ====================================
            */

            return {

                ok: true,

                requiere_adenda: false

            };


        } catch (error) {


            /*
            ====================================
            ADENDA OBLIGATORIA
            ====================================

            El backend responde:

            HTTP 409
            {
                msg: '...',
                requiere_adenda: true
            }

            Este caso NO es un error genérico.

            No mostramos SweetAlert porque
            Anamnesis.js deberá abrir el modal
            y conservar los cambios escritos
            por el profesional.
            ====================================
            */

            if (
                error.response?.status === 409 &&
                error.response?.data?.requiere_adenda === true
            ) {

                dispatch(
                    almacenarAnamnesisError(
                        error.response.data
                    )
                );


                return {

                    ok: false,

                    requiere_adenda: true

                };

            }


            /*
            ====================================
            OTROS ERRORES
            ====================================

            En cualquier otro error, mostramos
            el mensaje correspondiente.

            No abrimos el modal de adenda.
            ====================================
            */

            const mensaje =
                error.response?.data?.msg ||
                'No se pudo guardar la Anamnesis.';


            dispatch(
                almacenarAnamnesisError(
                    error.response?.data || {
                        msg: mensaje
                    }
                )
            );


            Swal.fire(
                'Error',
                mensaje,
                'error'
            );


            return {

                ok: false,

                requiere_adenda: false

            };

        }

    };

};


/*
====================================
ACTION CREATORS
====================================
*/

const almacenarAnamnesis = () => ({

    type: ALMACENAR_ANAMNESIS,

    payload: true

});


const almacenarAnamnesisExito = (data) => ({

    type: ALMACENAR_ANAMNESIS_EXITO,

    payload: data

});


const almacenarAnamnesisError = (error) => ({

    type: ALMACENAR_ANAMNESIS_ERROR,

    payload: error

});


/*
====================================
ACTUALIZAR ANAMNESIS EN REDUX
====================================

Se utiliza la action existente para
actualizar state.informacion.info_anamnesis.
====================================
*/

const solicitarAnamnesisExito = (datosAnamnesis) => ({

    type: SOLICITO_ANAMNESIS_EXITO,

    payload: datosAnamnesis

});